import { fabric } from "fabric";

/** True when an 8-number quad describes an axis-aligned rectangle. */
export function coordsAreAxisAlignedQuad(coords) {
    if (!Array.isArray(coords) || coords.length !== 8) {
        return false;
    }
    const xs = [coords[0], coords[2], coords[4], coords[6]];
    const ys = [coords[1], coords[3], coords[5], coords[7]];
    const minX = Math.min(...xs);
    const maxX = Math.max(...xs);
    const minY = Math.min(...ys);
    const maxY = Math.max(...ys);
    const eps = 1e-5;
    for (let i = 0; i < 4; i += 1) {
        const onVertical = Math.abs(xs[i] - minX) < eps || Math.abs(xs[i] - maxX) < eps;
        const onHorizontal = Math.abs(ys[i] - minY) < eps || Math.abs(ys[i] - maxY) < eps;
        if (!onVertical || !onHorizontal) {
            return false;
        }
    }
    return (maxX - minX) > eps && (maxY - minY) > eps;
}

/** Convert an 8-number quad into [x, y, w, h]. */
export function quadCoordsToXYWH(coords) {
    const xs = [coords[0], coords[2], coords[4], coords[6]];
    const ys = [coords[1], coords[3], coords[5], coords[7]];
    const minX = Math.min(...xs);
    const minY = Math.min(...ys);
    return [minX, minY, Math.max(...xs) - minX, Math.max(...ys) - minY];
}

/** Bake a polygon's transform into its points and reset scale/rotation. */
export function normalizePolygonAfterTransform(obj) {
    if (!obj || !obj.is_polygon || !obj.points || !obj.points.length) {
        return;
    }
    const matrix = obj.calcTransformMatrix();
    const pathOffset = obj.pathOffset || new fabric.Point(0, 0);
    const newPoints = obj.points.map((p) => {
        const local = new fabric.Point(p.x - pathOffset.x, p.y - pathOffset.y);
        const transformed = fabric.util.transformPoint(local, matrix);
        return { x: transformed.x, y: transformed.y };
    });
    obj.set({
        points: newPoints,
        scaleX: 1,
        scaleY: 1,
        angle: 0,
        skewX: 0,
        skewY: 0,
        flipX: false,
        flipY: false,
    });
    if (typeof obj.setBoundingBox === 'function') {
        obj.setBoundingBox(true);
    }
    obj.setCoords();
}
